import React, { useState } from 'react'
import tablePic from "../../../../images/jarvis/png/table_placeholder.png"
import CustomTable from '../table/Table'
import { Modal } from 'antd'

const RenderTable = ({ message }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const openModal = () => {
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setIsModalOpen(false)
    }

    return (
        <>
            <style>
                {`
                    .ant-modal-content {
                        height: 90vh !important;
                        position: relative !important;
                        background-color: #151515 !important;
                        background-clip: padding-box !important;
                        border: 0 !important;
                        border-radius: 8px !important;
                        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
                            0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
                        pointer-events: auto !important;
                        padding: 10px !important;
                    }
                    .ant-modal-body {
                        overflow-y: auto;
                        height: 100%;
                    }

                    .ant-modal {
                        top: 10px !important;
                        overflow: hidden;
                        padding: 10px !important;
                    }

                    .ant-modal-close {
                        position: absolute;
                        top: 12px;
                        inset-inline-end: 12px;
                        z-index: 1010;
                        padding: 0;
                        color: rgb(255, 255, 255) !important;
                        font-weight: 600;
                        line-height: 1;
                        text-decoration: none;
                        background: #686868 !important;
                        border-radius: 4px;
                        width: 32px;
                        height: 32px;
                        border: 0;
                        outline: 0;
                        cursor: pointer;
                        transition: color 0.2s, background-color 0.2s;
                    }
                    .ant-modal-wrap {
                        inset: 0;
                        z-index: 1000;
                        overflow: auto;
                        outline: 0;
                        max-width: 550px;
                        position: fixed;
                    }
                `}
            </style>

            <div>
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "300px",
                        backgroundImage: `url(${tablePic})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "bold",
                            cursor: "pointer",
                        }}
                        onClick={openModal}
                    ></div>
                </div>
                <Modal
                    open={isModalOpen}
                    onCancel={closeModal}
                    footer={null}
                    style={{
                        maxWidth: "100%",
                        width: "550px",
                        marginLeft: "auto",
                        marginRight: "auto",
                    }}
                >
                    {
                        <CustomTable data={message?.graph?.graph_data} />
                    }
                </Modal>
            </div>
        </>
    )
}

export default RenderTable